import { TokenPairSelector } from 'components/TokenPairSelector'
import { useTokenPairOptions } from 'components/TokenPairSelector/useTokenPairOptions'
import { MAX_XVVS_BOOST_FACTOR, MAX_NUM_OF_BOOST_FARM } from 'config/constants/farmBoost'
import { useTranslation } from 'contexts/Localization'
import { useState, useContext } from 'react'
import styled, { useTheme } from 'styled-components'
import xVvsContext from 'views/xVvs/context'
import { Box, Button, Flex, InfoIcon, Message, Text, useMatchBreakpoints } from 'vvs-uikit'
import { BoostFarmModalStep as Step } from 'views/xVvs/types'
import { useGetBoostedFarms } from 'hooks/boost-farm/useFarmBoostContract'

export const SelectBoostFarmStep: React.FC<{ setStep: (step) => void }> = ({ setStep }) => {
  const { colors } = useTheme()
  const { t } = useTranslation()
  const {
    setSelectedBoostFarms,
    state: { selectedBoostFarms },
  } = useContext(xVvsContext)
  const { isMobile } = useMatchBreakpoints()

  const { data: boostedFarms } = useGetBoostedFarms()

  const { pairOptions } = useTokenPairOptions({
    boostMultiplier: MAX_XVVS_BOOST_FACTOR,
  })

  const [selectedIds, setSelectedIds] = useState<number[]>(() => {
    return selectedBoostFarms.map((v) => v.id) || []
  })

  const handleConfirm = () => {
    setSelectedBoostFarms(
      pairOptions
        .filter((v) => selectedIds.includes(v.id))
        .map((v) => ({
          id: v.id,
          tokenPair: v.tokenPair,
          tokenRewardsApr: v.tokenRewardsApr,
          lpRewardsApr: v.lpRewardsApr,
          version: v.version,
          lpToken: v.lpToken,
        })),
    )
    setStep(Step.CONFIRM_BOOST)
  }

  return (
    <Box p="0 24px">
      <Flex flexDirection="column" gap="16px">
        <StyledMessage filled variant="info" icon={<InfoIcon width={19.2} height={19.2} color={colors.primary} />}>
          <StyledMessageText>
            {t('Select up to maximum %maxNum% farms to boost', { maxNum: MAX_NUM_OF_BOOST_FARM })}
          </StyledMessageText>
          {boostedFarms?.length > 0 && (
            <StyledMessageTextBolder>
              {t(' (Boosted %boostedNum% / %maxNum% already )', {
                boostedNum: boostedFarms?.length,
                maxNum: MAX_NUM_OF_BOOST_FARM,
              })}
            </StyledMessageTextBolder>
          )}
        </StyledMessage>
      </Flex>
      <TokenPairSelector
        limit={MAX_NUM_OF_BOOST_FARM - (boostedFarms?.length || 0)}
        defaultValues={selectedIds}
        onSelect={(ids) => {
          setSelectedIds(ids)
        }}
        options={pairOptions?.filter((v) => !boostedFarms?.includes(v.id))}
      />
      <StickyFlex paddingY="24px" paddingBottom={isMobile ? '70px' : '0px'}>
        <Button width="100%" height="60px" disabled={selectedIds.length === 0} onClick={handleConfirm}>
          {t('Save and Continue Boost')}
        </Button>
      </StickyFlex>
    </Box>
  )
}

const StickyFlex = styled(Flex)`
  position: sticky;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  z-index: ${({ theme }) => theme.zIndices.modal + 1};
`

const StyledMessage = styled(Message)`
  height: 60px;
  svg {
    margin-right: 10px;
  }
`

const StyledMessageText = styled(Text)`
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #000000;
`

const StyledMessageTextBolder = styled(StyledMessageText)`
  font-weight: 700;
  text-indent: 10px;
`
